<kc-icon
  [iconClass]="iconClass"
  [size]="size()"
  [color]="iconColor"
  class="copy-button cursor-pointer"
  (click)="copyValue()"
/>
